import { ActiveFilters } from '@grid/abstractions';
import { FilterMap } from '@shared/modules/prime-grid-filters/helpers/types/filter-map.type';

export class QueryFilterState implements ActiveFilters {
  private activeFilter: FilterMap;

  constructor() {
    this.activeFilter = new Map();
  }

  update(filter: FilterMap): void {
    this.activeFilter = filter;
  }

  get<T>(key: string): T | undefined {
    if (this.activeFilter.has(key)) {
      return this.activeFilter.get(key)!.getValue<T>();
    }
    return undefined;
  }
}
